import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { productService } from "../../../services/product";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column"; 

import { Toolbar } from "primereact/toolbar";
import useDebounce from "../../../components/ui/useDebounce";
import { Paginator } from "primereact/paginator";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

export default function SysWarehouseProducts() {
   
  const [first, setFirst] = useState(0);
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState("");
  const filterChange = (e) => {
    setFilter(e.target.value);
  };
  const debouncedFilter = useDebounce(filter, 600);

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    setPage(event.page + 1);
  };

  const { data: apiResponse, isLoading } = useQuery({
    queryKey: ["warehouseProducts", page, rows, debouncedFilter],
    queryFn: () =>
      productService.getAllWarehouseProducts(page, rows, debouncedFilter),
  });
  useEffect(() => {
    const totalRecords = apiResponse?.totalRecords || 0;
    setTotalRecords(totalRecords);
  }, [apiResponse]); 
 
  const products = Array.isArray(apiResponse?.data) ? apiResponse.data : [];
   
  
  const partiBodyTemplate = (rowData) => {

    return (<div>{rowData.belgeNo} / {rowData.parti}</div>);
  };
 
  const cols = [
    { field: "tarihFormatted", header: "Tarih" },
    { field: "unvan", header: "Firma" },
    { field: "urun", header: "Ürün" },
    { field: "belgeNo", header: "Parti No" ,body:partiBodyTemplate }, 
    { field: "kg", header: "Kg"  },
    { field: "mt", header: "Mt"  },
  ];

 
  
const footer = (
    <Paginator
    first={first}
    rows={rows}
    totalRecords={totalRecords}
    rowsPerPageOptions={[10, 30, 50]}
    onPageChange={onPageChange}
    className="p-0 m-0 border-none"
    disabled={isLoading} // Yüklenme sırasında paginator'ı devre dışı bırak
  />
  );

  return (
    <div >
   
      <Toolbar
                     className="shadow-3 border-round-md  my-2"
                     start={
                       <div className="text-2xl font-bold"> Tüm Depo Ürünleri</div>
                     }
                     end={
                       <IconField iconPosition="left">
                         <InputIcon className="pi pi-search" />
                         <InputText
                           type="search"
                           value={filter || ""}
                           className="w-full"
                           onChange={(e) => filterChange(e)}
                           placeholder="Ara"
                         />
                       </IconField>
                     }
                   />
   
        <DataTable   loading={isLoading}
          emptyMessage="Liste Boş"  scrollable scrollHeight="flex"
          footer={footer}  className="shadow-3 border-round-md table-content surface-ground "
          value={products || []}
          tableStyle={{ minWidth: "50rem" }}
        >
          {cols.map((col, i) => (
            <Column key={i} field={col.field} header={col.header}  body={col.body}/>
          ))}
        
        </DataTable>
      
    </div>
  );
}
